import React from 'react'
import PropTypes from 'prop-types'
import { Panel } from 'react-bootstrap'

const FAQBody = ({
  createUserEvent,
  category, // 'faqs'
  action, // ie: 'ToggleSecondary Category'
  target, // category name
  bodyStyle,
  children
}) => {
  return (
    <Panel.Collapse
      onEntered={() =>
        createUserEvent({
          category: category,
          data: { action, target }
        })
      }
    >
      <Panel.Body style={bodyStyle}>{children}</Panel.Body>
    </Panel.Collapse>
  )
}

FAQBody.propTypes = {
  createUserEvent: PropTypes.func.isRequired,
  category: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  target: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bodyStyle: PropTypes.object,
  children: PropTypes.node
}

export default FAQBody



// WEBPACK FOOTER //
// ./src/components/FAQ/FAQBody.js